var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#EDE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_40880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 25.5H27.1667C26.2462 25.5 25.5 26.2462 25.5 27.1667V34.6667C25.5 35.5871 26.2462 36.3333 27.1667 36.3333H34.6667C35.5871 36.3333 36.3333 35.5871 36.3333 34.6667V27.1667C36.3333 26.2462 35.5871 25.5 34.6667 25.5Z",
    stroke: "#322267",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.166 30.4993H21.3327C20.8907 30.4993 20.4667 30.3238 20.1542 30.0112C19.8416 29.6986 19.666 29.2747 19.666 28.8327V21.3327C19.666 20.8907 19.8416 20.4667 20.1542 20.1542C20.4667 19.8416 20.8907 19.666 21.3327 19.666H28.8327C29.2747 19.666 29.6986 19.8416 30.0112 20.1542C30.3238 20.4667 30.4993 20.8907 30.4993 21.3327V22.166",
    stroke: "#322267",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_40880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefCopy);
export default __webpack_public_path__ + "static/media/ref_copy.fb1922c3c81a91a3c90e8c4bc27b4551.svg";
export { ForwardRef as ReactComponent };